(function () {
  'use strict';

  // Sumo Logic client-side event helper (from Chris M's reference file).
  // Fires client events to the engagement Sumo collector. Fail-open:
  // logging must never block UX.

  var SUMO_CLIENT_ENDPOINT = "https://endpoint1.collection.us2.sumologic.com/receiver/v1/http/ZaVnC4dhaV24b1XTAVyXf_Ah3_25xiUsQy1HqEcjGf52g95jxcnvsU6IRYiiFujWUiAPSYv_bikd5di_19AKLNQvrhzDS8JHERKDgEnHXbgkj6GDgmdoiw==";
  var APP_VERSION = "1.0.0";

  function getSessionId() {
    var id = null;
    try { id = sessionStorage.getItem("engagement_session_id"); } catch (e) {}
    if (!id) {
      id = (window.crypto && window.crypto.randomUUID)
        ? window.crypto.randomUUID()
        : (Date.now() + '-' + Math.random().toString(36).slice(2));
      try { sessionStorage.setItem("engagement_session_id", id); } catch (e) {}
    }
    return id;
  }

  function logClientEvent(opts) {
    opts = opts || {};
    var payload = Object.assign({
      event_name: opts.event_name,
      module: opts.module,
      shopify_customer_id: opts.shopify_customer_id,
      session_id: getSessionId(),
      source_ref: opts.source_ref || null,
      contest_key: opts.contest_key || null,
      game_id: opts.game_id || null,
      result: opts.result || null,
      error_type: opts.error_type || null,
      latency_ms: opts.latency_ms == null ? null : opts.latency_ms,
      placement: opts.placement || null,
      page_url: window.location.href,
      timestamp: new Date().toISOString(),
      app_version: APP_VERSION
    }, opts.extra || {});

    try {
      fetch(SUMO_CLIENT_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Sumo-Name": "shopify-client-engagement",
          "X-Sumo-Category": "engagement/client/" + (opts.module || 'unknown')
        },
        body: JSON.stringify(payload),
        keepalive: true
      }).catch(function () {});
    } catch (e) {
      // Fail open. Logging must never block UX.
    }
  }

  window.logClientEvent = logClientEvent;
})();
